export default __webpack_public_path__ + "static/media/hdb-blob-3.78c1bd94.svg";